/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createValidationProblemDetailsFromDiscriminatorValue, type ValidationProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Invoice/Download/{id}
 */
export interface DownloadItemRequestBuilder extends BaseRequestBuilder<DownloadItemRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     get(requestConfiguration?: RequestConfiguration<DownloadItemRequestBuilderGetQueryParameters> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<DownloadItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface DownloadItemRequestBuilderGetQueryParameters {
    isPostData?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const DownloadItemRequestBuilderUriTemplate = "{+baseurl}/Invoice/Download/{id}?isPostData={isPostData}";
/**
 * Metadata for all the requests in the request builder.
 */
export const DownloadItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: DownloadItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
    },
};
/* tslint:enable */
/* eslint-enable */
